define('app/sdc/require/sdc-require',["$anchorScroll", "$animate", "$compile", "$q", "$rootScope"], function ($anchorScroll, $animate, $compile, $q, $rootScope) {
	var sdcRequire = {
		restrict: "ECA",
		terminal: true,
		priority: 400,
		transclude: "element",
		controller: angular.noop,
		scope: false,
		compile: function (element, attr) {
			var moduleIdExp = attr.sdcRequire || attr.module,
				onloadExp = attr.onload || '',
				autoScrollExp = attr.autoscroll;

			return ["$scope", "$element", "$attrs", "$self", "$transclude", function (scope, $element, $attr, ctrl, $transclude) {
				var changeCounter = 0,
					currentScope,
					previousElement,
					currentElement;

				var cleanupLastRequireContent = function () {
					if (previousElement) {
						previousElement.remove();
						previousElement = null;
					}
					if (currentScope) {
						currentScope.$destroy();
						currentScope = null;
					}
					if (currentElement) {
						$animate.leave(currentElement).then(function () {
							previousElement = null;
						});
						previousElement = currentElement;
						currentElement = null;
					}
				};

				scope.$watch(moduleIdExp, function ngIncludeWatchAction(moduleId) {
					function getTemplate() {
						return $q(function ($return, $throw) {
							if (require.defined(moduleId)) {
								try {
									$return(require(moduleId));
									if (!$rootScope.$$phase) {
										scope.digest();
									}
								}
								catch (ex) {
									$throw(ex);
								}
							}
							else {
								require([moduleId], function (template) {
									$return(template);
								}, function (err) {
									$throw(err);
								});
							}
						});
					}
					var afterAnimation = function () {
						if (angular.isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
							$anchorScroll();
						}
					};
					var thisChangeId = ++changeCounter;

					if (moduleId) {
						//set the 2nd param to true to ignore the template request error so that the inner
						//contents and scope can be cleaned up.
						getTemplate().then(function (template) {
							if (thisChangeId !== changeCounter) return;
							var newScope = scope.$new();
							ctrl.template = template;

							// Note: This will also link all children of ng-include that were contained in the original
							// html. If that content contains controllers, ... they could pollute/change the scope.
							// However, using ng-include on an element with additional content does not make sense...
							// Note: We can't remove them in the cloneAttchFn of $transclude as that
							// function is called before linking the content, which would apply child
							// directives to non existing elements.
							var clone = $transclude(newScope, function (clone) {
								cleanupLastRequireContent();
								$animate.enter(clone, null, $element).then(afterAnimation);
							});

							currentScope = newScope;
							currentElement = clone;

							currentScope.$emit('$requireContentLoaded', moduleId);
							scope.$eval(onloadExp);
						}, function (err) {
							if (thisChangeId === changeCounter) {
								cleanupLastRequireContent();
								scope.$emit('$requireContentError', moduleId);
							}
						});
						scope.$emit('$requireContentRequested', moduleId);
					} else {
						cleanupLastRequireContent();
						ctrl.template = null;
					}
				});
			}];
		}
	};
	var sdcRequireFillContent = {
		restrict: 'ECA',
		priority: -400,
		require: 'sdcRequire',
		scope: false,
		link: ["$scope", "$element", "$attrs", "$self", function (scope, $element, $attr, ctrl) {
			if (/SVG/.test($element[0].toString())) {
				// WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
				// support innerHTML, so detect this here and try to generate the contents
				// specially.
				$element.empty();
				$compile(jqLiteBuildFragment(ctrl.template, document).childNodes)(scope,
					function namespaceAdaptedClone(clone) {
						$element.append(clone);
					}, undefined, undefined, $element);
				return;
			}

			$element.html(ctrl.template);
			$compile($element.contents())(scope);
		}]
	};
	return [sdcRequire, sdcRequireFillContent];
});
